export const SORTING_ERROR = 'The number of suggestions exceeds the maximum allowed. Please clarify your criteria';

export const COLUMNS: Record<string, string> = {
    ACCOUNT_NAME: 'accountName',
    ACCOUNT_STATUS: 'accountStatus',
    LICENSE_TYPE: 'licenseType',
    LICENSED_ENABLED_USERS: 'licensedEnabledUsers',
    LICENSE_END_DATE: 'licenseEndDate',
    CONFERENCE_END_DATE: 'conferenceEndDate',
    PRIMARY_ACCOUNT_MANAGER: 'primaryAccountManager',
};

export const SELECTED_COLUMNS: string[] = [
    COLUMNS.ACCOUNT_NAME,
    COLUMNS.ACCOUNT_STATUS,
    COLUMNS.LICENSE_TYPE,
    COLUMNS.LICENSED_ENABLED_USERS,
    COLUMNS.LICENSE_END_DATE,
    COLUMNS.CONFERENCE_END_DATE,
    COLUMNS.PRIMARY_ACCOUNT_MANAGER,
];

export const HEADERS = {
    [COLUMNS.ACCOUNT_NAME]: 'Account Name',
    [COLUMNS.ACCOUNT_STATUS]: 'Account Status',
    [COLUMNS.LICENSE_TYPE]: 'License Type',
    [COLUMNS.LICENSED_ENABLED_USERS]: 'Licensed Enabled Users',
    [COLUMNS.LICENSE_END_DATE]: 'License End Date',
    [COLUMNS.CONFERENCE_END_DATE]: 'Conference End Date',
    [COLUMNS.PRIMARY_ACCOUNT_MANAGER]: 'Primary Account Team Member',
};

export const LOADING_PRIORITY: Array<{columnId: string, chunk: string, priority: number}> = [
    {chunk: 'license', columnId: COLUMNS.LICENSE_TYPE, priority: 1},
    {chunk: 'license', columnId: COLUMNS.LICENSE_END_DATE, priority: 2},

    {chunk: 'conference', columnId: COLUMNS.CONFERENCE_END_DATE, priority: 1},
];

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.ACCOUNT_NAME,
        fixed: true,
        defaultWidth: 400,
        minWidth: 400,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.ACCOUNT_STATUS,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.LICENSE_TYPE,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.LICENSED_ENABLED_USERS,
        fixed: false,
        defaultWidth: 200,
        minWidth: 170,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.LICENSE_END_DATE,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.CONFERENCE_END_DATE,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.PRIMARY_ACCOUNT_MANAGER,
        fixed: false,
        defaultWidth: 300,
        minWidth: 300,
        maxWidth: 520,
    },
];

export const SELECTION_KEY = 'user-conferences-accounts';
export const PLACE = 'User Conferences';
